export default {
    getPlanTypes: { method: 'get', url: 'emcadmin/plan-types' },
    postPlanTypes: { method: 'post', url: 'emcadmin/plan-types' },
    putPlanTypes: { method: 'put', url: 'emcadmin/plan-types/{id}' },
    deletePlanTypes: { method: 'delete', url: 'emcadmin/plan-types/{id}' },
}
